import React from 'react';
import brandCatalystActive from '../../../images/salescatalyst/SC_Logo_White.png';

const BrandCatalystComingSoonToolPalate = () => (
  <div className="insight360-width-455 minimize-tp float-left">
    <ul className="insight360_tool_bg">
      <li className="salescatalyst_tool_btn_sale">
        <button className="tool_img open_tool insight360_tool_btn deafult-cursor">
          <img
            className="salescatalyst_tool_img_sale"
            src={brandCatalystActive}
            alt=""
          />
        </button>
      </li>
    </ul>
  </div>
);

export default BrandCatalystComingSoonToolPalate;

